import { BitkitTabs } from '@bitrise/bitkit-v2';

import { Attachment } from '../../../TestResults.types';
import AttachmentsTabContent from './AttachmentsTabContent';
import AttachmentsEmptyState from './components/AttachmentsEmptyState';

const AttachmentsTab = ({ attachments }: { attachments: Attachment[] }) => {
  if (attachments.length === 0) {
    return (
      <BitkitTabs.Content value="attachments">
        <AttachmentsEmptyState />
      </BitkitTabs.Content>
    );
  }

  return (
    <BitkitTabs.Content value="attachments" padding="16" gap="8" display="grid" gridTemplateColumns="1fr 1fr 1fr">
      <AttachmentsTabContent attachments={attachments} />
    </BitkitTabs.Content>
  );
};

export default AttachmentsTab;
